import React from 'react'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'

export default function ResetGenPassword() {
	return (
		<div className='position-absolute d-flex align-items-center justify-content-center text-center' style={{
			// background: 'rgba(0,0,0,0.7)',
			top: '0px'
			, bottom: '0px'
			, left: '0px'
			, right: '0px'
			, zIndex: 10999
			}}>
		<div
			// style={{ maxHeight: '80vh', minHeight: '80vh', minWidth: '80vw' }}
			className='bg-primary-container text-white text-dark p-3 rounded shadow'>
    			{<h3>Password Reset</h3> }
                    <div className={` h-50 ${'bg-secondary-container'} p-2 rounded`}
                        style={{ overflow: 'auto'}}>
                        <p>You have logged in with a temporary password. Please enter a new secure password</p>
                        <input placeholder='New Password' className='form-control' />
                        
                    </div>
                    <button className='btn mt-3'>Save and continue</button>
			</div>

		</div>
	)
}
